import { YYYYMMDD } from "@/helpers/dateHelper";
import { DirectionEnum } from "@/models/enums";
import { dialogKey, DialogMessage, DialogType } from "@/models/symbols/Dialog";
import { useBookingStore } from "@/store/booking";
import { useEventBus } from "@vueuse/core";
import { computed } from "vue";

const useDayTrip = () => {
	const bookingStore = useBookingStore();
	const bus = useEventBus<DialogMessage>(dialogKey);

	const isDayTrip = computed(() => {
		return YYYYMMDD(bookingStore.getBooking.outward.date ?? new Date()) ===
			YYYYMMDD(bookingStore.getBooking.return.date ?? new Date())
	});

	const openDayTripDialog = (date: string | undefined) => {
		bus.emit({
			title: "Daytrip",
			message: `<p>You have selected a day trip ticket. 
			You can only book this departure with the day 
			trip fare when travelling and returning on the 
			same day.</p> <p> If you wish to book day trip, please 
			cancel this message and go back and select the same 
			outward and return journey dates <strong>OR</strong> 
			click continue and get a new price for your selected
			departure</p>`,
			yes: "continue",
			no: "cancel",
			callback: () => {
				//update the return date if customer press continue in dialog
				bookingStore.setDate(DirectionEnum.Return, new Date(date ?? new Date()));

				//also update the outward date with its old value to trigger a new fetch from the server
				//since the price needs to be updated for both outward and return departures if daytrip is cancelled
				const outwardDate = bookingStore.getDate(DirectionEnum.Outward);
				bookingStore.setDate(DirectionEnum.Outward, new Date(outwardDate ?? new Date()));
			},
			type: DialogType.Info
		} as DialogMessage);
	}

	const openDayTripConfirmationDialog = (cb: () => void) => {
		bus.emit({
			title: "Daytrip price terms",
			message: `<p>You are purchasing a day trip ticket, if you stay on the Isles of Scilly for longer than a day you will be charged our full return fare at check-in on your return journey. You will need to pay in full before being allowed to board.</p>`,
			confirmation: 'Please tick the box to confirm you understand the statement above.',
			yes: 'Proceed',
			no: 'Cancel',
			callback: cb,
			type: DialogType.Info
		})
	}

	return { isDayTrip, openDayTripDialog, openDayTripConfirmationDialog }
}

export default useDayTrip;